"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
}), _react.default.createElement("circle", {
  cx: "7.5",
  cy: "16.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "7.5",
  cy: "7.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "16.5",
  cy: "16.5",
  r: "1.5"
}), _react.default.createElement("circle", {
  cx: "16.5",
  cy: "7.5",
  r: "1.5"
})), 'CasinoOutlined');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/CasinoOutlined.js
// module id = 1469
// module chunks = 0